import { render, staticRenderFns } from "./FormUpload.vue?vue&type=template&id=53c15ec9&scoped=true&lang=pug&"
import script from "./FormUpload.vue?vue&type=script&lang=js&"
export * from "./FormUpload.vue?vue&type=script&lang=js&"
import style0 from "./FormUpload.vue?vue&type=style&index=0&id=53c15ec9&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c15ec9",
  null
  
)

export default component.exports